import { useEffect } from "react";
import "./App.css";

export default function Home() {
  return (
    <div className="container">
      <div className="logo_container">
        <img src="/original.webp" alt="s10 brand" width={150} height={100} />
        <span>making life easy for physicians</span>
      </div>
      <img
        src="/s10_new_log.webp"
        alt="s10 logo"
        style={{ marginTop: "5rem" }}
      />
    </div>
  );
}
